// components/meta-tags.gts
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import type MetaService from '../services/meta';

interface MetaTagComponentSignature {
  Args: Record<string, never>;
}

export default class MetaTagsComponent extends Component<MetaTagComponentSignature> {
  @service('-document') declare document: Document;
  @service declare meta: MetaService;

  // The head element to render into
  get headElement(): HTMLHeadElement {
    return this.document.head;
  }

  constructor(owner: unknown, args: MetaTagComponentSignature['Args']) {
    super(owner, args);
    this.tearDownHead();
  }

  @action
  tearDownHead(): void {
    // Remove any existing title element created by our meta service to avoid conflicts
    const existingTitles = this.document.querySelectorAll('title[data-meta-service]');

    for (const title of existingTitles) {
      this.headElement.removeChild(title);
    }
  }

  <template>
    {{#in-element this.headElement insertBefore=null}}
      {{this.meta.headContent}}
    {{/in-element}}
  </template>
}

